import useEntity from "../../hooks/useShipmentHistory";
import ShipmentHistoryDetail from "../../components/shipmentHistory/ShipmentHistoryDetail/ShipmentHistoryDetail";
import ShipmentHistoryScoped from "../../components/shipmentHistory/ShipmentHistoryDetail/ShipmentHistoryScoped";
import ShipmentHistoryTabs from "../../components/shipmentHistory/ShipmentHistoryDetail/ShipmentHistoryTabs";
import { useGetShipmentHistoryQuery } from "../../apis/ShipmentHistory.api";
import { PrimaryShipmentHistory } from "../../types/models/ShipmentHistory";
import React from "react";
import {Delete, Edit} from "@mui/icons-material";
import {Box, Paper, Stack, Button} from "@mui/material";
import {NavLink, useParams, useSearchParams} from "react-router";
import {useStateSession} from "../../../hooks/useAuth";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const ShipmentHistoryDetailPage = () => {

    useTitle(t`Details Shipment History`);

    const session = useStateSession()
    const [searchParams] = useSearchParams();
    const scoped = searchParams.get("scoped");
    const { shipmentHistoryId: id } = useParams();

    const { data, refetch } = useGetShipmentHistoryQuery(PrimaryShipmentHistory.fromPath(id))
    const { deleteShipmentHistory } = useEntity();

    const onDelete = React.useCallback((e: any) => {
        e.stopPropagation()
        deleteShipmentHistory(data, '..')
    }, [data, deleteShipmentHistory])

    if (id === 'scoped') {
        return (<ShipmentHistoryScoped/>)
    }

    return (
        <Box data-testid="ShipmentHistory-details">
            { data && <Paper sx={ { padding: "2em" } }>
                <ShipmentHistoryDetail data={data} refetch={refetch} scoped={scoped}/>
                <Stack direction="row" spacing={1} sx={{ justifyContent: "center", marginTop: "2em"}}>
                    
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/ShipmentHistories/delete/view'
        ) ||
false) &&
                        <Button size="small" color="error" variant="outlined" data-testid="ShipmentHistory-delete-button" startIcon={<Delete />}  onClick={(e) => onDelete(e)}>
                            <Trans>Delete</Trans>
                        </Button>
                    }
                </Stack>
            </Paper>}

            { data && <Stack direction="row" spacing={1} sx={ { marginTop: "2em" } }>
                <ShipmentHistoryTabs data={data} />
            </Stack>}
        </Box>
    )
}

export default ShipmentHistoryDetailPage;
